import { Box, LinearProgress, Typography, Divider } from "@mui/material";
import React, { useState } from "react";
import GlobalButton from "../../../components/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Information from "./Information";
import AboutVenue from "./AboutVenue";
import BusinessPhone from "./BusinessPhone";
import BusinessLocation from "./BusinessLocation";
import OpeningHours from "./OpeningHours";
import ShowCase from "./ShowCase";
import VenueImageGuidelines from "./VenueImageGuidelines";
import UpdateVenueImages from "./UpdateVenueImages";
import ShowCaseTwo from "./ShowCaseTwo";
import AboutFees from "./AboutFees";
import EnableOnlineBookings from "./EnableOnlineBookings";
import { useNavigate } from "react-router-dom";
import appcolors from "../../../constants/Colors";

const stepsList = [
  {
    id: 1,
    name: "Step 1",
    value: "1",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 2,
    name: "",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 3,
    name: "",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 4,
    name: "",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 5,
    name: "",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 6,
    name: "Step 2",
    value: "2",
    isActive: false,
    stepColor: appcolors.primary,
  },
  {
    id: 7,
    name: "",
    isActive: true,
    stepColor: appcolors.primary,
  },
  {
    id: 8,
    name: "",
    isActive: true,
    stepColor: "rgb(92 169 244)",
  },
  {
    id: 9,
    name: "Step 3",
    value: "3",
    isActive: false,
    stepColor: "rgb(31 168 136)",
  },
  {
    id: 10,
    name: "",
    isActive: true,
    stepColor: "rgb(31 168 136)",
  },
  {
    id: 11,
    name: "",
    isActive: true,
    stepColor: "rgb(31 168 136)",
  },
];

const daysss = [
  {
    id: 1,
    name: "Monday",
    selected: true,
    startTime: "",
    endTime: "",
  },
  {
    id: 2,
    name: "Tuesday",
    selected: true,
    startTime: "",
    endTime: "",
  },
  {
    id: 3,
    name: "Wednesday",
    selected: true,
    startTime: "",
    endTime: "",
  },
  {
    id: 4,
    name: "Thursday",
    selected: true,
    startTime: "",
    endTime: "",
  },
  {
    id: 5,
    name: "Friday",
    selected: true,
    startTime: "",
    endTime: "",
  },
  {
    id: 6,
    name: "Saturday",
    selected: false,
    startTime: "",
    endTime: "",
  },
  {
    id: 7,
    name: "Sunday",
    selected: false,
    startTime: "",
    endTime: "",
  },
];

const BranchSignupSteps = () => {
  const navigate = useNavigate();
  const [selectedDays, setSelectedDays] = useState(daysss);
  const [inputValues, setInputValues] = useState({
    venueCoverImage: "",
    venueImages: [],
  });
  const [currentStep, setCurrentStep] = useState(1);

  return (
    <Box sx={{ paddingTop: "20px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: "800px",
          overflowX: "auto",
          margin: "0 20px",
          justifyContent: "center",
        }}
      >
        {stepsList?.map((stepppp, index) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {stepppp.name !== "" ? (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "25px",
                      width: "25px",
                      // marginRight: "10px",
                      borderRadius: "50%",
                      background: stepppp.id <= currentStep ? "orange" : "none",
                      border: `2.5px solid ${
                        stepppp.id <= currentStep
                          ? "orange"
                          : "rgb(196 196 196)"
                      }`,
                    }}
                    // onClick={() => {
                    //   setCurrentStep(stepppp);
                    //   setNestedStep(null);
                    // }}
                  >
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: "600",
                        color: stepppp.id <= currentStep ? "white" : "black",
                      }}
                    >
                      {stepppp.value}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{ width: "20px", borderBottomWidth: "medium" }}
                  />
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "15px",
                      width: "15px",
                      // marginRight: "10px",
                      borderRadius: "50%",
                      background:
                        stepppp.id <= currentStep
                          ? "orange"
                          : "rgb(196 196 196)",
                    }}
                  ></Box>
                  <Divider
                    sx={{
                      width: "20px",
                      display: stepppp?.id == 11 ? "none" : "block",
                      borderBottomWidth: "medium",
                    }}
                  />
                </>
              )}
            </Box>
          );
        })}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          margin: "8px 10px 15px",
          justifyContent: currentStep > 1 ? "space-between" : "flex-end",
        }}
      >
        {currentStep > 1 && (
          <Box
            sx={{
              border: "2px solid black",
              borderRadius: "10px",
              padding: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              if (currentStep == 1) {
              } else setCurrentStep(currentStep - 1);
            }}
          >
            <ArrowBackIcon />
          </Box>
        )}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {/* <Box sx={{ marginRight: "10px" }}>
            <GlobalButton
              variant={"contained"}
              btnText={"Save and exit"}
              styleProps={{ background: "#fff", color: "black" }}
              handleClickBtn={() => navigate("/login")}
            />
          </Box> */}
          {currentStep < 11 && (
            <Box sx={{ marginRight: "10px" }}>
              <GlobalButton
                variant={"contained"}
                btnText={"Continue"}
                styleProps={{ background: "#fff", color: "black" }}
                handleClickBtn={() => {
                  setCurrentStep(currentStep + 1);
                }}
              />
            </Box>
          )}
        </Box>
      </Box>

      {currentStep == 1 && <Information />}
      {currentStep == 2 && <AboutVenue />}
      {currentStep == 3 && <BusinessPhone />}
      {currentStep == 4 && <BusinessLocation />}
      {currentStep == 5 && (
        <OpeningHours
          selectedDays={selectedDays}
          setSelectedDays={setSelectedDays}
        />
      )}

      {currentStep == 6 && <ShowCase />}
      {currentStep == 7 && <VenueImageGuidelines />}
      {currentStep == 8 && (
        <UpdateVenueImages
          inputValues={inputValues}
          setInputValues={setInputValues}
        />
      )}

      {currentStep == 9 && <ShowCaseTwo />}
      {currentStep == 10 && <AboutFees />}
      {currentStep == 11 && <EnableOnlineBookings />}
    </Box>
  );
};

export default BranchSignupSteps;
